import { Link } from 'react-router-dom';
import IvWhite from "../../assets/icons/IvoryList.svg";
import Image from '../../components/ui/Image';
import { useTranslation } from 'react-i18next';

const SeminarBox = ({ seminar }) => {
    const seeMoreBtn = seminar?.description?.length > 100;
    const { t } = useTranslation();
    return (
        <Link
            to={`/seminars/${seminar?.id}`}
            className="border p-3 rounded-lg w-full h-full text-wrap"
        >
            <div className="relative w-full">
                <div className="w-full h-80 !text-start text-black bg-gray-200 rounded-md relative">
                    <Image src={seminar?.image} alt={seminar?.title} className="object-cover w-full h-full rounded-md relative z-0" />
                    <div className='absolute w-full h-full top-0 bg-[var(--hidden-red)] z-10 rounded-md'></div>
                </div>
                <div className='relative my-4 z-20'>
                    <div>
                        <p className='bg-secondary-tw text-white flex justify-center items-center gap-2 rounded-lg absolute text-wrap w-11/12 max-lg:w-11/12 left-4 max-lg:left-4 bottom-3 py-1 px-3 text-base z-20'>
                            <span>
                                <img src={IvWhite} alt='ivory-icon' />
                            </span>
                            <span className='text-base'>
                                {seminar?.title}
                            </span>
                        </p>
                    </div>
                </div>
                <div className="!text-start text-wrap text-black">
                    <div
                        dangerouslySetInnerHTML={{
                            __html:
                                seminar?.description?.substring(0, 100) +
                                (seeMoreBtn
                                    ? `<button style="all:unset; text-decoration: underline; color: #6a2f38; font-size: 0.875rem; white-space: nowrap; margin-right: 4px;">${t('custom.show-more')} ...</button>`
                                    : ''),
                        }}
                    />
                </div>

            </div>
        </Link>
    )
}
export default SeminarBox;